<template>
<ItpBox
  alignItems="center"
>
  <ItpIcon
    :name="$config.register.icon"
    spacing="mr-3"
    :title="'Register'|pgettext('Register')"
    class="mr-2"
    v-if="!noIcon"
  >
  </ItpIcon>
  <ItpBox
    direction="column"
  >
    <div
      class="mr-2"
      v-if="item.version"
    >
      {{ item.version.name }} &middot; {{ item.version.company_name }}
    </div>
    <ItpBox
      alignItems="center"
    >
      <ItpText
        strong
        :text="item.entry_number"
        class="mr-2"
      >
      </ItpText>
      <ItpLink
        :icon="$config.externalLinkIcon"
        @click.prevent.stop="evh_3601807637515735_clickPreventStop($event, {})"
      >
      </ItpLink>
    </ItpBox>
  </ItpBox>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcRegisterEntryMiniCard extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  noIcon!: boolean;

  @Watch('noIcon')
  onNo_icon(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("noIcon")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  async act_3601807637515735_showModal_8258_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_3601807637515735_showModal_8258, alias=undefined
    return {
      name: "RegisterEntry",
      props: {
        oid: this.item.id,
      }
      ,
    }
  }

  async evh_3601807637515735_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3601807637515735_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_3601807637515735_showModal_8258: actions.ShowModalAction;
    evh_3601807637515735_clickPreventStop_8257: actions.EventHandlerImpl;
    evh_3601807637515735_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_3601807637515735_showModal_8258 = new actions.ShowModalAction(
      {
        actionArgs: this.act_3601807637515735_showModal_8258_getActionArgs,
        events: [],
      }
    );
    const evh_3601807637515735_clickPreventStop_8257 = new actions.EventHandlerImpl(
      {
        action: act_3601807637515735_showModal_8258,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_3601807637515735_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_3601807637515735_clickPreventStop_8257],
      }
    );
    return {
      act_3601807637515735_showModal_8258,
      evh_3601807637515735_clickPreventStop_8257,
      evh_3601807637515735_clickPreventStop,
    }
  }
}

Vue.component("UcRegisterEntryMiniCard", UcRegisterEntryMiniCard);

</script>